import { moduleWrapper } from '../components/moduleWrapper';
/**
 * This adds a listener to determine your location.
 * @category Event listener
 */
export const addGeoLocationListener = function () {
  return moduleWrapper.current.functions.addGeoLocationListener(...arguments);
};
/**
 * Adds a listener for scroll event by user.
 * @category Event listener
 */
export const addScrollListener = function () {
  return moduleWrapper.current.functions.addScrollListener(...arguments);
};
/**
 * This method will be executed when the page gets displayed or hidden.
 * @category Event listener
 */
export const addVisibilityChangeListener = function () {
  return moduleWrapper.current.functions.addVisibilityChangeListener(...arguments);
};
/**
 * This adds a listener to get the actual height of the page.
 * @category Event listener
 */
export const addWindowMetricsListener = function () {
  return moduleWrapper.current.functions.addWindowMetricsListener(...arguments);
}; /**
   * Allows a custom callback function to be defined
   */
export const customCallbackFunction = function () {
  return moduleWrapper.current.functions.customCallbackFunction(...arguments);
};
/**
 * Get the accessToken from the user.
 */
export const getAccessToken = function () {
  return moduleWrapper.current.functions.getAccessToken(...arguments);
};
/**
 * This method returns a list of installed share/social media apps.
 */
export const getAvailableSharingServices = function () {
  return moduleWrapper.current.functions.getAvailableSharingServices(...arguments);
};
/**
 * This method determines your location. If you want to track a route, use addGeoLocationListener.
 */
export const getGeoLocation = function () {
  return moduleWrapper.current.functions.getGeoLocation(...arguments);
};
/**
 * This method returns user information for a specific user.
 * @category User functions
 */
export const getUserInfo = function () {
  return moduleWrapper.current.functions.getUserInfo(...arguments);
};
/**
 * Return the current scroll position of the top frame
 */
export const getScrollPosition = function () {
  return moduleWrapper.current.functions.getScrollPosition(...arguments);
};
/**
 * Returns the window metrics.
 */
export const getWindowMetrics = function () {
  return moduleWrapper.current.functions.getWindowMetrics(...arguments);
};
/** @internal */
export const invokeCall = function () {
  return moduleWrapper.current.functions.invokeCall(...arguments);
};
/** @internal */
export const invokeDialogCall = function () {
  return moduleWrapper.current.functions.invokeDialogCall(...arguments);
};
/**
 * This method will show a login dialog where the user has the opportunity to log in.
 */
export const login = function () {
  return moduleWrapper.current.functions.login(...arguments);
};
/**
 * This method will logout the user
 */
export const logout = function () {
  return moduleWrapper.current.functions.logout(...arguments);
};
/**
 * This function navigates you to the previous site.
 */
export const navigateBack = function () {
  return moduleWrapper.current.functions.navigateBack(...arguments);
};
/**
 * The images specified in the url array is shown in gallery mode.
 */
export const openImage = function () {
  return moduleWrapper.current.functions.openImage(...arguments);
};
/**
 * The images and videos specified in the items array is shown in gallery mode.
 */
export const openMedia = function () {
  return moduleWrapper.current.functions.openMedia(...arguments);
};
/**
 * Opens an URL in the chayns environment.
 */
export const openUrl = function () {
  return moduleWrapper.current.functions.openUrl(...arguments);
};
/**
 * The video specified in the URL is shown in video mode.
 */
export const openVideo = function () {
  return moduleWrapper.current.functions.openVideo(...arguments);
};
/**
 * Refresh badge count in navigation, user information and pages
 */
export const refreshData = function () {
  return moduleWrapper.current.functions.refreshData(...arguments);
};
/**
 * Refresh accesstoken, should only be used when user object changes, not when token is invalid
 */
export const refreshAccessToken = function () {
  return moduleWrapper.current.functions.refreshAccessToken(...arguments);
};
/**
 * This removes a listener to determine your location.
 * @category Event listener
 */
export const removeGeoLocationListener = function () {
  return moduleWrapper.current.functions.removeGeoLocationListener(...arguments);
};
/**
 * Removes scroll listener.
 * @category Event listener
 */
export const removeScrollListener = function () {
  return moduleWrapper.current.functions.removeScrollListener(...arguments);
};
/**
 * Removes visibility change listener.
 * @category Event listener
 */
export const removeVisibilityChangeListener = function () {
  return moduleWrapper.current.functions.removeVisibilityChangeListener(...arguments);
};
/**
 * Removes window metrics listener.
 * @category Event listener
 */
export const removeWindowMetricsListener = function () {
  return moduleWrapper.current.functions.removeWindowMetricsListener(...arguments);
};
/**
 * Select other page on chayns site.
 */
export const selectPage = function () {
  return moduleWrapper.current.functions.selectPage(...arguments);
};
/**
 * Scrolls by specific amount.
 */
export const scrollByY = function () {
  return moduleWrapper.current.functions.scrollByY(...arguments);
};
/**
 * Scrolls to specific position.
 */
export const scrollToY = function () {
  return moduleWrapper.current.functions.scrollToY(...arguments);
};
/**
 * Sends intercom message to group.
 */
export const sendMessageToGroup = function () {
  return moduleWrapper.current.functions.sendMessageToGroup(...arguments);
};
/**
 * Sends intercom message to page.
 */
export const sendMessageToPage = function () {
  return moduleWrapper.current.functions.sendMessageToPage(...arguments);
};
/**
 * Sends intercom message to an user.
 */
export const sendMessageToUser = function () {
  return moduleWrapper.current.functions.sendMessageToUser(...arguments);
};
/**
 * Switches admin mode, also toggles admin switch in top frame.
 */
export const setAdminMode = function () {
  return moduleWrapper.current.functions.setAdminMode(...arguments);
};
/**
 * Sets the display timeout, only works in chayns App.
 */
export const setDisplayTimeout = function () {
  return moduleWrapper.current.functions.setDisplayTimeout(...arguments);
};
/**
 * Enables or disables a button which floats over the page.
 */
export const setFloatingButton = function () {
  return moduleWrapper.current.functions.setFloatingButton(...arguments);
};
/**
 * Sets the height of the page.
 */
export const setHeight = function () {
  return moduleWrapper.current.functions.setHeight(...arguments);
};
/**
 * Enables or disables the ability to refresh a page
 */
export const setRefreshScrollEnabled = function () {
  return moduleWrapper.current.functions.setRefreshScrollEnabled(...arguments);
};
/**
 * Scans a qr-code and returns the result
 */
export const setScanQrCode = function () {
  return moduleWrapper.current.functions.setScanQrCode(...arguments);
};
/**
 * Temporarily change design settings in top frame
 */
export const setTempDesignSettings = function () {
  return moduleWrapper.current.functions.setTempDesignSettings(...arguments);
};
/**
 * Shows or hide a waitcursor
 */
export const setWaitCursor = function () {
  return moduleWrapper.current.functions.setWaitCursor(...arguments);
};
/**
 * Retrieves the value that is assigned to the key from a storage outside the frame
 */
export const storageGetItem = function () {
  return moduleWrapper.current.functions.storageGetItem(...arguments);
};
/**
 * Removes the value that is assigned to the key from a storage outside the frame
 */
export const storageRemoveItem = function () {
  return moduleWrapper.current.functions.storageRemoveItem(...arguments);
};
/**
 * Sets the value that is assigned to the key from a storage outside the frame
 */
export const storageSetItem = function () {
  return moduleWrapper.current.functions.storageSetItem(...arguments);
};
/**
 * This method lets a smartphone vibrate for the given time.
 */
export const vibrate = function () {
  return moduleWrapper.current.functions.vibrate(...arguments);
};
/**
 * This method creates a dialog
 */
export const createDialog = function () {
  return moduleWrapper.current.functions.createDialog(...arguments);
};
/**
 * Displays an overlay
 */
export const setOverlay = function () {
  return moduleWrapper.current.functions.setOverlay(...arguments);
};
/**
 * Returns user information, only when user is logged in
 * @category User functions
 */
export const getUser = () => moduleWrapper.current.values.user;
export const getSite = () => moduleWrapper.current.values.site;
export const getCurrentPage = () => moduleWrapper.current.values.currentPage;
export const getDevice = () => moduleWrapper.current.values.device;
export const getLanguage = () => moduleWrapper.current.values.language;
export const getParameters = () => moduleWrapper.current.values.parameters;
export const getPages = () => moduleWrapper.current.values.pages;
export const getEnvironment = () => moduleWrapper.current.values.environment;
export const user = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren;
    console.warn('Deprecated user import');
    return (_moduleWrapper$curren = moduleWrapper.current.values.user) === null || _moduleWrapper$curren === void 0 ? void 0 : _moduleWrapper$curren[prop];
  }
});
export const site = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren2;
    console.warn('Deprecated site import');
    return (_moduleWrapper$curren2 = moduleWrapper.current.values.site) === null || _moduleWrapper$curren2 === void 0 ? void 0 : _moduleWrapper$curren2[prop];
  }
});
export const device = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren3;
    console.warn('Deprecated device import');
    return (_moduleWrapper$curren3 = moduleWrapper.current.values.device) === null || _moduleWrapper$curren3 === void 0 ? void 0 : _moduleWrapper$curren3[prop];
  }
});
export const language = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren4;
    console.warn('Deprecated language import');
    return (_moduleWrapper$curren4 = moduleWrapper.current.values.language) === null || _moduleWrapper$curren4 === void 0 ? void 0 : _moduleWrapper$curren4[prop];
  }
});
export const parameters = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren5;
    console.warn('Deprecated parameters import');
    return (_moduleWrapper$curren5 = moduleWrapper.current.values.parameters) === null || _moduleWrapper$curren5 === void 0 ? void 0 : _moduleWrapper$curren5[prop];
  }
});
export const pages = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren6;
    console.warn('Deprecated pages import');
    return (_moduleWrapper$curren6 = moduleWrapper.current.values.pages) === null || _moduleWrapper$curren6 === void 0 ? void 0 : _moduleWrapper$curren6[prop];
  }
});
export const environment = new Proxy({}, {
  get: (target, prop) => {
    var _moduleWrapper$curren7;
    console.warn('Deprecated environment import');
    return (_moduleWrapper$curren7 = moduleWrapper.current.values.environment) === null || _moduleWrapper$curren7 === void 0 ? void 0 : _moduleWrapper$curren7[prop];
  }
});